import React from 'react';

import { Bootstrap } from '../../bootstrap';
import { CustomerDataProvider } from '../../contexts/customer-data-context';
import { FeatureFlagsProvider } from '../../contexts/feature-flags-context';
import { I18nProvider } from '../../contexts/i18n-context';
import { PaymentErrorProvider } from '../../contexts/payment-error-context';
import { PaymentStateProvider } from '../../contexts/payment-state-context';
import { toTelemetryContext } from '../../core/logs';
import { PaymentConfig } from '../../types';
import { normalizeToFullLocale } from '../../utils/i18n';
import { mountReactRoot } from '../../utils/root-registry';
import { PaymentWidgetWrapper } from './payment-widget-wrapper';

export const mountPaymentWidget = (
    container: HTMLElement,
    config: PaymentConfig
) => {
    const locale = normalizeToFullLocale(config.locale);

    return mountReactRoot(
        container,
        <React.StrictMode>
            <FeatureFlagsProvider flags={config.featureFlags}>
                <I18nProvider
                    config={{
                        locale,
                        messages: config.i18n,
                        devMode: config.devMode
                    }}
                >
                    <Bootstrap styling={config.styling}>
                        <PaymentErrorProvider
                            onError={config.onError}
                            telemetryContext={toTelemetryContext(config)}
                        >
                            <PaymentStateProvider
                                onPaymentStateChange={
                                    config.onPaymentStateChange
                                }
                            >
                                <CustomerDataProvider
                                    initialData={config.customerFields}
                                >
                                    <PaymentWidgetWrapper
                                        config={{ ...config, locale }}
                                        container={container}
                                    />
                                </CustomerDataProvider>
                            </PaymentStateProvider>
                        </PaymentErrorProvider>
                    </Bootstrap>
                </I18nProvider>
            </FeatureFlagsProvider>
        </React.StrictMode>
    );
};
